"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _PropertyIdentifier = require("customer-data-objects/property/PropertyIdentifier");

var _PropertyRecord = _interopRequireDefault(require("customer-data-objects/property/PropertyRecord"));

var _react = _interopRequireWildcard(require("react"));

var _SyntheticEvent = _interopRequireDefault(require("UIComponents/core/SyntheticEvent"));

var _UINumberInput = _interopRequireDefault(require("UIComponents/input/UINumberInput"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _omit = _interopRequireDefault(require("transmute/omit"));

var _RecordTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/RecordTypesType"));

var defaultProps = {
  onChange: _emptyFunction.default
};
var propTypes = {
  multiCurrencyCurrencyCode: _react.PropTypes.string,
  onChange: _react.PropTypes.func.isRequired,
  property: _react.PropTypes.instanceOf(_PropertyRecord.default).isRequired,
  subject: _react.PropTypes.oneOfType([_RecordTypesType.default, _react.PropTypes.instanceOf(_immutable.Map)]),
  value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])
};

var PropertyInputNumber =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PropertyInputNumber, _React$Component);

  function PropertyInputNumber() {
    var _this;

    (0, _classCallCheck2.default)(this, PropertyInputNumber);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputNumber).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(PropertyInputNumber, [{
    key: "focus",
    value: function focus() {
      this.refs.input.focus();
      this.refs.input.select();
    }
  }, {
    key: "handleChange",
    value: function handleChange(evt) {
      var _evt$target = evt.target;
      _evt$target = _evt$target === void 0 ? {} : _evt$target;
      var nextValue = _evt$target.value;
      var _this$props = this.props,
          onChange = _this$props.onChange,
          property = _this$props.property,
          value = _this$props.value;

      if (nextValue !== value) {
        var isUnformattedNumericPropertyType = (typeof nextValue === 'number' || !(0, _PropertyIdentifier.isFormattedNumber)(property)) && !isNaN(nextValue);
        var nextEvent = isUnformattedNumericPropertyType || !nextValue || typeof nextValue.replace !== 'function' ? evt : (0, _SyntheticEvent.default)(nextValue.replace(/\D/g, ''));
        onChange(nextEvent);
      }
    }
  }, {
    key: "formatValue",
    value: function formatValue(value) {
      if (value == null || value === '') {
        return '';
      }

      return _I18n.default.formatNumber(value, {
        precision: 5
      });
    }
  }, {
    key: "parseValue",
    value: function parseValue(value) {
      if (!value && value !== 0) {
        return undefined;
      }

      var parsedValue = parseFloat(value);

      if (isNaN(parsedValue)) {
        return undefined;
      }

      return parsedValue;
    }
  }, {
    key: "render",
    value: function render() {
      var property = this.props.property;
      var transferableProps = (0, _omit.default)(['baseUrl', 'caretRenderer', 'isInline', 'isExpandableTextInputEnabled', 'getProperty', 'objectType', 'onCancel', 'onInvalidProperty', 'propertyIndex', 'propertyInputComponentConfig', 'readOnlySourceData', 'resolver', 'resolvers', 'showError', 'showPlaceholder', 'subject', 'subjectId', 'secondaryChanges', 'onSecondaryChange', 'wrappers', 'onTracking', 'isRequired'], (0, _immutable.Seq)(this.props)).toJS();

      if ((0, _PropertyIdentifier.isFormattedNumber)(property)) {
        return _react.default.createElement(_UINumberInput.default, (0, _extends2.default)({
          formatter: this.formatValue
        }, transferableProps, {
          value: this.parseValue(this.props.value),
          onChange: this.handleChange,
          ref: "input"
        }));
      }

      return _react.default.createElement(_UITextInput.default, (0, _extends2.default)({}, transferableProps, {
        onChange: this.handleChange,
        ref: "input"
      }));
    }
  }]);
  return PropertyInputNumber;
}(_react.default.Component);

exports.default = PropertyInputNumber;
PropertyInputNumber.propTypes = propTypes;
PropertyInputNumber.defaultProps = defaultProps;
module.exports = exports.default;